import React from 'react';
import { Link } from 'src/components/Inputs';

const ModulrTermsEU = ({}) => {
  return (
    <>
      <h4 id='modulr-terms-eu' data-magellan-target='modulr-terms-eu'>
        Modulr Terms and Conditions (EU)
      </h4>
      <p>
        <em>Last Updated: 10 June 2025</em>
      </p>
      <p>
        <strong>Introduction</strong>
      </p>
      <p>
        Plaid B.V. is a partner of Modulr Finance B.V., a company registered in
        the Netherlands with company number 81852401, which is authorised and
        regulated by the Dutch Central Bank (DNB) as an Electronic Money
        Institution (Firm Reference Number: R182870) for the issuance of
        electronic money and payment services. Your account and related payment
        services are provided by Modulr Finance B.V. Your funds will be held in
        one or more segregated accounts and safeguarded in line with the
        Financial Supervision Act - for more information please see{' '}
        <Link href='#eea-safeguarding'>
          <a data-smooth-scroll data-offset='80'>
            this link
          </a>
        </Link>
        {'.'}
      </p>
      <p>
        <Link href='#eea-safeguarding'>
          <a data-smooth-scroll data-offset='80'>
            EEA Safeguarding
          </a>
        </Link>
      </p>
      <p id='modulr-terms-eu-background'>
        <strong>Background</strong>
      </p>
      <p>
        Modulr Finance B.V. (“Modulr”) is a provider of Modulr Products (as
        described to you by Partner Platform), which includes the provision of
        an electronic money account for businesses and associated payment
        services. These Introduced Client Terms of Business govern the Modulr
        Products that Modulr agrees to provide to the Introduced Client.
        <br />
        These Introduced Client Terms of Business (including all the attached
        Schedules), together with the Modulr Account Terms and Conditions set
        out the terms on which the Modulr Products are provided and constitute
        the Agreement between Modulr and the Introduced Client.
      </p>
      <p>
        <strong>THE PARTIES AGREE AS FOLLOWS:</strong>
      </p>
      <ol>
        <li>
          <strong>Interpretation</strong>
          <ol>
            <li>
              In these Introduced Client Terms of Business: (a) a reference to a
              clause is a reference to a clause in these Introduced Client Terms
              of Business; (b) headings are for reference only and shall not
              affect the interpretation of these Introduced Client Terms of
              Business; (c) the singular shall include the plural and vice
              versa; (d) a reference to a person includes a natural person,
              corporate or unincorporated body (whether or not having separate
              legal personality) and that person's personal representatives,
              successors and permitted assigns; (e) a reference to a party shall
              include its personal representatives, successors and permitted
              assigns; (f) reference to a statute or statutory provision is a
              reference to it as amended, extended or re-enacted from time to
              time.
            </li>
          </ol>
          <br />
        </li>
        <li>
          <strong>Modulr Products</strong>
          <ol>
            <li>
              Modulr will make available to the Introduced Client such products
              that are provided to the Partner Platform and as described by
              Partner Platform in the application process.
            </li>
            <li>
              The Introduced Client agrees to the Partner Platform providing all
              such information to Modulr who will check and verify the identity
              of the Introduced Client, its directors, beneficial owners and
              Authorised Users as required by law.
            </li>
            <li>
              The Introduced Client acknowledges that a search of the available
              public registers may take place for anti-money laundering purposes
              on the individuals listed in clause 2.2 above.
            </li>
            <li>
              The Introduced Client acknowledges that the individuals noted in
              clause 2.2 above may have their their personal details accessed by
              third parties for the specific purpose of anti-money laundering
              and countering the financing of terrorism (AML/CFT), identity
              verification and fraud prevention.
            </li>
            <li>
              The Account is provided by Modulr to the Introduced Client in
              accordance with the Modulr Account Terms and Conditions. Modulr
              Products provided to the Introduced Client under this Agreement
              are for the sole use by the Introduced Client.
            </li>
            <li>
              The Introduced Client can use the Account and Cards (where
              applicable) to make Transactions on the terms and conditions set
              out in the Modulr Account Terms and Conditions. A record of all
              Transactions relating to the Account can viewed on the Website or
              accessed via the Partner Platform (as applicable).
            </li>
            <li>
              The Introduced Client shall promptly notify Customer Services as
              soon as it becomes aware login and security information enabling
              access to its Modulr Products have been lost, stolen or
              compromised.
            </li>
            <li>
              From time to time Modulr may carry out additional checks on the
              Introduced Client, including the identity of its directors,
              beneficial owners and the nature of its business in accordance
              with its Due Diligence Procedure and as required by law. Modulr
              may contact the Introduced Client or the Partner Platform (as
              applicable) for such purposes. The Introduced Client agrees to
              provide such information as necessary.
            </li>
            <li>
              The Introduced Client shall comply with all legislation and
              regulation as it applies to the Introduced Client. Any failure to
              comply with relevant legislation or regulation shall be considered
              a material breach of the Agreement and may result in Modulr
              discontinuing the provision of the Modulr Products as set out in
              clause 6.4.
            </li>
            <li>
              The Introduced Client shall implement as appropriate Modulr's
              reasonable security recommendations it notifies to the Introduced
              Client from time to time.
            </li>
          </ol>
          <br />
        </li>
        <li>
          <strong>Authorised Users</strong>
          <ol>
            <li>
              Access to the Modulr Products is restricted to individuals that
              have been designated by the Introduced Client as Authorised Users.
            </li>
            <li>
              The Introduced Client must notify Modulr of all individuals it
              wishes to be an Authorised User.
            </li>
            <li>
              Each Authorised User is permitted to access and use the Modulr
              Products in accordance with these Introduced Client Terms of
              Business.
            </li>
            <li>
              The Introduced Client shall ensure that each Authorised User
              complies with these Introduced Client Terms of Business.
            </li>
            <li>
              The Introduced Client shall ensure its Authorised Users;
              <ol>
                <li>
                  take all reasonable care to ensure Modulr Product access
                  credentials, including login details to the Website, where
                  applicable, are kept confidential to each Authorised User; and
                </li>
                <li>
                  do not share any information that would enable another party
                  to access the Introduced Client's Modulr Account.
                </li>
              </ol>
            </li>
            <li>
              The Introduced Client acknowledges and agrees that each Authorised
              User is authorised by the Introduced Client to act on its behalf.
              Modulr shall deem any instruction given by an Authorised User is
              an instruction given by the Introduced Client.
            </li>
            <li>
              The Introduced Client will be responsible for timely notification
              to Modulr of any revocation of Authorised User access and will be
              liable for Transactions made, Fees incurred and use of Modulr
              Products by an Authorised User until Modulr has had two full
              Business Days to act on any received notice. This clause shall not
              apply to Introduced Clients accessing Modulr Products via the
              Partner Platform.
            </li>
            <li>
              Where the Introduced Client accesses Modulr Products through a
              Partner Platform, such Partner Platform will be considered the
              Authorised User. In this instance if additional Authorised Users
              are required they must be requested by the Partner Platform. The
              use of a Partner Platform to access the Modulr Products by the
              Introduced Client are set out in further detail below.
            </li>
          </ol>
          <br />
        </li>
        <li>
          <strong>Accessing Modulr Products through a Partner Platform</strong>
          <ol>
            <li>
              In the event the Introduced Client utilizes a Partner Platform to
              access Modulr Products, the Introduced Client agrees and
              authorises the Partner Platform to instruct Modulr to access and
              use the Modulr Products on behalf of the Introduced Client, which
              shall include but not be limited to making Transactions, viewing
              and retrieving Transaction data, initiating refunds and closing
              the Account.
            </li>
            <li>
              The Introduced Client acknowledges and agrees that Modulr shall
              have no liability whatsoever with respect to the performance,
              availability or quality of any Partner Platform.
            </li>
            <li>
              The Introduced Client acknowledges and agrees to the following:
            </li>
            <ol>
              <li>
                it must satisfy itself that its Platform Partner Agreement
                grants the Partner Platform all permission necessary to operate
                the Account on the Introduced Client's behalf;
              </li>
              <li>
                the Platform Partner will be granted full access to operate the
                Introduced Client's Account as an Authorised User of the
                Introduced Client;
              </li>
              <li>
                it is responsible for monitoring Partner Platform activities on
                its Account. Any queries relating to such activities will be
                raised with the Partner Platform directly and settled between
                Partner Platform and the Introduced Client;
              </li>
              <li>
                the Introduced Client has no recourse against Modulr for any act
                or omission of the Partner Platform with respect to its Account;
              </li>
              <li>
                the Introduced Client understands it can only access its Account
                to make Transactions, review Transactions made or otherwise use
                Modulr Products through the service provided by the Partner
                Platform; and
              </li>
              <li>
                it will only use the Account for the purpose set out in the
                Partner Platform Agreement.
              </li>
            </ol>
            <li>
              On receipt of notification by Modulr from the Partner Platform
              that it wishes to terminate this Agreement, this Agreement shall
              terminate. Any funds in the Introduced Client's Account will be
              returned in accordance with the terms of the Modulr Account Terms
              and Conditions.
            </li>
            <li>
              If the Introduced Client has any complaint or concern relating to
              the Modulr Account or other Modulr Products, such complaint or
              concern shall be raised directly to the Partner Platform, who
              shall deal with it in accordance with Modulr's Complaints Policy,
              a copy of which is available on request from the Partner Platform
              and on the Website.
            </li>
          </ol>
          <br />
        </li>
        <li>
          <strong>Customer Services</strong>
          <ol>
            <li>
              The Introduced Client can contact Customer Services if it has any
              queries about the Modulr Products. Information may be requested
              from the Introduced Client, including but not limited to, its
              Authorised Users, Cardholders or Transaction information so that
              it can verify the identity of an Authorised User , the Cardholder
              and/or the Modulr Products provided to such Introduced Client.
            </li>
            <li>
              Any information shared by the Introduced Client will be kept
              strictly confidential. Where such information is provided in
              connection to a service provided by a third party, for example,
              the Account, then the Introduced Client's information will only be
              used in accordance with instructions of such third party and only
              for the purpose of providing Customer Services to the Introduced
              Client on behalf of such third party.
            </li>
            <li>
              As part of Modulr's commitment to providing a quality customer
              service, its managers periodically monitor telephone
              communications between its employees and Introduced Clients to
              ensure that Modulr's high quality service standards are
              maintained. The Introduced Client consents to such monitoring and
              recording of telephone communications and agrees to make its
              Authorised Users aware of such practice.
            </li>
          </ol>
          <br />
        </li>
        <li>
          <strong>Term and Termination </strong>
          <ol>
            <li>
              This Agreement shall commence on the date the Introduced Client
              receives confirmation from Modulr or the Partner Platform (where
              applicable) of its successful application for Modulr Products and
              shall continue until terminated by the Introduced Client, Partner
              Platform (if acting on behalf of the Introduced Client) or Modulr.
            </li>
            <li>
              The Introduced Client or the Partner Platform (where applicable)
              may terminate this Agreement immediately by notifying Customer
              Services in writing by post or email.
            </li>
            <li>
              Modulr may terminate this Agreement and close the Introduced
              Client's Account(s) by providing the Introduced Client with at
              least two months' notice.
            </li>
            <li>
              Modulr may suspend or terminate this Agreement immediately if, for
              any reason, the Introduced Client (i) is unable to satisfy the Due
              Diligence Procedures, (ii) for breach of this Agreement, (iii) has
              provided false, incomplete or misleading information, (iv) has
              engaged in fraudulent, money laundering, terrorism financing or
              other illegal activity or we have reasonable suspicions in respect
              of same or (v) we are required to do so under any applicable law
              or regulation or at the direction of any regulatory, law
              enforcement or other competent authority. Modulr shall notify you
              as soon as possible, unless prohibited by law, of such suspension
              or termination of the Agreement.
            </li>
            <li>
              This Agreement will automatically terminate when all Accounts of
              the Introduced Client are closed (for any reason).
            </li>
            <li>
              Modulr may terminate or suspend this Agreement in whole or in part
              immediately by giving written notice to the Introduced Client if
              Modulr ceases to provide Cards pursuant to this Agreement.
            </li>
            <li>
              On termination of this Agreement for any reason, any balance
              remaining in the Introduced Client's Account(s) shall be returned
              to the Introduced Client in accordance with the Modulr Account
              Terms and Conditions. The Introduced Client shall pay immediately
              all outstanding Fees due (where applicable) under this Agreement
              and in the event of a negative balance in an Account, shall
              reimburse Modulr such amount equal to the negative balance.
            </li>
          </ol>
          <br />
        </li>
        <li>
          <strong>Intellectual Property</strong>
          <ol>
            <li>
              The Introduced Client acknowledges all Intellectual Property
              Rights in the Modulr Products are owned by or provided under
              licence to Modulr. Modulr grants the Introduced Client a
              non-exclusive, royalty-free licence for the duration of this
              Agreement to access and use the Modulr Products only for the
              purpose contemplated by this Agreement.
            </li>
            <li>
              Nothing in this Agreement shall operate to create or transfer any
              Intellectual Property Right to the Introduced Client.
            </li>
          </ol>
          <br />
        </li>
        <li>
          <strong>ConfideForce Majeure</strong>
          <ol>
            <li>
              Modulr will not be liable for the non-performance or failure to
              provide any part of the Modulr Products occurring as a result of
              any events that are beyond the reasonable control of Modulr, for
              example, but not limited to, fire, telecommunications or internet
              failure, utility failure, power failure, equipment failure,
              employment strife, riot, war, terrorist attack, non-performance of
              third party suppliers, acts of God such as storm or lightening
              damage, or other causes over which Modulr has no reasonable
              control.
            </li>
          </ol>
          <br />
        </li>
        <li>
          <strong>Assignment Transfer and Subcontracting</strong>
          <ol>
            <li>
              The Modulr Products provided to the Introduced Client are personal
              to the Introduced Client. The Introduced Client cannot novate,
              assign or otherwise transfer this Agreement, any interest or right
              under this Agreement (in whole or in part) without the prior
              written consent of Modulr. This clause shall have proprietary
              effect (goederenrechtelijke werking).
            </li>
            <li>
              The Introduced Client agrees Modulr may, in its sole discretion,
              assign, or transfer some or all of its rights and obligations or
              delegate any duty of performance set out in the documents forming
              this Agreement. Modulr may subcontract any of its obligations
              under this Agreement.
            </li>
            <li>
              In the event of any transfer of this Agreement by Modulr to
              another service provider, Modulr will notify the Introduced Client
              no later than two months before the proposed transfer; if the
              Introduced Client does not want to transfer to the new provider,
              the Introduced Client must notify Modulr of its objection in
              writing to Customer Services. On receipt of such notification,
              Modulr will terminate this Agreement. Any balance remaining in the
              Introduced Client's Account(s) will be returned to the Introduced
              Client in accordance with the redemption procedure set out in the
              Modulr Account Terms and Conditions.
            </li>
          </ol>
          <br />
        </li>
        <li>
          <strong>Liability</strong>
          <ol>
            <li>
              Nothing in this Agreement will operate to limit either party's
              liability with respect to fraud or for death or personal injury
              resulting from negligence, in either case whether committed by
              that party or its employees, agents or subcontractors.
            </li>
            <li>
              Modulr makes no warranty that access to and use of the Modulr
              Products will be uninterrupted or error free.
            </li>
            <li>
              The Introduced Client acknowledges and agrees that Modulr is not
              liable to the Introduced Client for any loss, liability or damages
              the Introduced Client suffers which result from, are related to,
              or in any way are connected with any fraud control, restriction
              measures, or other measures implemented from time to time
              including as required for compliance with legal and regulatory
              requirements, unless such loss, liability or damage is a direct
              result of Modulr's fraud, gross negligence or willful misconduct
              in procuring the implementation of fraud control or purchase
              restriction measures that Modulr has expressly agreed in writing
              to procure for the Introduced Client.
            </li>
            <li>
              Modulr shall not be liable to the Introduced Client for any loss
              or damage the Introduced Client may suffer as a result of any act
              or omission of an Authorised User or Cardholder or an Authorised
              User's use or Cardholder's use or inability to use of the Modulr
              Products.
            </li>
            <li>
              The Introduced Client agrees to indemnify Modulr against any and
              all actions, claims, costs, damages, demands, expenses,
              liabilities, losses and proceedings Modulr directly or indirectly
              incurs or which are brought against Modulr if the Introduced
              Client, or an Authorised User, or a Cardholder has acted
              fraudulently, been negligent or has misused a Modulr Product or
              any of the services provided under this Agreement.
            </li>
            <li>
              Modulr shall not be responsible in any way for any interest or
              claims of any third parties in respect of the Modulr Products,
              except as required by law or regulation.
            </li>
          </ol>
          <br />
        </li>
        <li>
          <strong>Reports</strong>
          <ol>
            <li>
              Modulr may make available certain management or other reporting or
              business administration functionality via the Website.
            </li>
            <li>
              Modulr may from time to time amend, modify, replace or withdraw in
              whole or in part such reporting it provides without further
              notice.
            </li>
          </ol>
          <br />
        </li>
        <li>
          <strong>Data Privacy</strong>
          <ol>
            <li>
              Modulr will collect and retain personal information about the
              Introduced Client and each Authorised User and Cardholder to
              enable Modulr to deliver the Modulr Products, the services linked
              to it and deal with any enquiries that the Introduced Client may
              have about it. Modulr is the data controller of the personal
              information gathered by Modulr for such purpose. If Modulr uses a
              third party to provide a part of the Modulr Product then that
              provider will be the owner and controller of the personal
              information they require to collect in order to operate the
              relevant service. The use of personal information by third-party
              service providers will be set out in their service terms and
              conditions of use. Modulr will, at such third-party provider's
              direction, process personal data on its behalf, for example, to
              enable Modulr to provide Customer Services to the Introduced
              Client.
            </li>
            <li>
              Modulr processes personal information in accordance with relevant
              laws on the protection of personal data.
            </li>
            <li>
              If Modulr transfers the Introduced Client's information to a third
              party in a country outside of the European Economic Area Modulr
              will ensure that the third party agrees to apply the same levels
              of protection that Modulr is legally obliged to have in place when
              Modulr processes personal data.
            </li>
            <li>
              Further information about how Modulr uses personal information can
              be found in Modulr's Privacy Policy; please contact Customer
              Services for a copy of this.
            </li>
          </ol>
          <br />
        </li>
        <li>
          <strong>Changes to the Agreement</strong>
          <ol>
            <li>
              Modulr may amend or modify this Agreement by giving two months'
              notice to the Introduced Client unless Modulr is required to make
              such a change sooner by law. All proposed changes will be posted
              on the Website and communicated to the Introduced Client by such
              other means that Modulr agreed with the Introduced Client, for
              example by email. If the Introduced Client is accessing Modulr
              Products via a Partner Platform, all notifications will be
              communicated via such Partner Platform.
            </li>
            <li>
              The Introduced Client has no obligation to accept such amendments
              proposed by Modulr.
            </li>
            <li>
              The Introduced Client will be taken to have accepted any change to
              this Agreement that Modulr notifies to the Introduced Client
              unless the Introduced Client tells Modulr otherwise before the
              relevant change takes effect. In such circumstances, Modulr will
              treat notice of objection by the Introduced Client as notification
              that the Introduced Client wishes to terminate this Agreement and
              the use of all Modulr Products immediately. All Accounts of the
              Introduced Client will be closed and any balance remaining in the
              Introduced Client's Account will be returned to the Introduced
              Client in accordance with the redemption procedure set out in the
              Modulr Account Terms and Conditions. In such circumstances, the
              Introduced Client will not be charged a fee for the Account
              closure and return of any balance.
            </li>
          </ol>
          <br />
        </li>
        <li>
          <strong>General</strong>
          <ol>
            <li>
              In these Introduced Client Terms of Business, headings are for
              convenience only and shall not affect the interpretation of these
              Introduced Client Terms of Business.
            </li>
            <li>
              Any delay or failure by Modulr to exercise any right or remedy
              under this Agreement shall not be interpreted as a waiver of that
              right or remedy or stop Modulr from exercising its rights at any
              subsequent time.
            </li>
            <li>
              In the event that any part of this Agreement is held not to be
              enforceable, this shall not affect the remainder of the Agreement
              which shall remain in full force and effect.
            </li>
            <li>
              The Introduced Client shall remain responsible for complying with
              this Agreement until its Account(s) are closed (for whatever
              reason) and all sums due under this Agreement have been paid in
              full.
            </li>
            <li>
              This Agreement is written and available only in English and all
              correspondence with the Introduced Client shall be in English.
            </li>
            <li>
              Exclusion of relevant statutory provisions: the following
              provisions of the Netherlands Civil Code do not apply in the
              relationship between Modulr and the Introduced Client: articles
              7:516, 7:517, 7:518 and 7:519, article 7:520(1), article 7:522(3),
              article 7:527, articles 7:529 to 7:531, article 7:534 and articles
              7:543, 7:544 and 7:545 Netherlands Civil Code and all legislation
              pursuant to and/or based on such articles. Furthermore, if not
              already covered by the articles referred to in the preceding
              sentence, the rules regarding provision of information in the
              Market Conduct Supervision (Financial Institutions) Decree
              (Besluit gedragstoezicht financiële ondernemingen Wft) that follow
              from Title III PSD2 do not apply. The above contains the exclusion
              of the relevant provisions of PSD2 as implemented in Dutch law.
              Consequently, all rules with regard to the content and provision
              of the information required by Title III of PSD2 and the following
              provisions of Title IV of PSD2 do not apply to this Agreement:
              article 62(1), article 64(3), article 72, article 74, article 76,
              article 77, article 80 and article 89 of PSD2 and all legislation
              pursuant to and/or based on such articles. This clause shall not
              apply if the Introduced Client is a Consumer
            </li>
            <li>
              This Agreement - and any contractual and non-contractual
              obligation pursuant hereto - is governed by the laws of the
              Netherlands and the Introduced Client agrees that any disputes
              hereunder (including non-contractual disputes) shall be under the
              exclusive jurisdiction of the competent Courts of Amsterdam.
            </li>
          </ol>
        </li>
      </ol>
      <p>
        <b>
          The Modulr Account Terms and Conditions;
          <br />
          Important information you need to know
          <br />
          Please read these Terms and Conditions carefully before you agree to
          use an Account or any related services provided by or through us.
          <br />
          These Terms and Conditions, together with the Introduced Client Terms
          of Business constitute the entire agreement between Modulr and you.
          <br />
          By accepting the Modulr Account Terms and Conditions you accept the
          terms of the Agreement, or by agreeing to open an Account and/or using
          our services, you accept these Terms and Conditions. If there is
          anything you do not understand, please contact Customer Services.
          <br />
        </b>
      </p>

      <ol>
        <li>
          <strong>Definitions</strong>
        </li>
        <ul>
          <li>
            <b>3DS</b> - means the EMV 3DS service offered by us for you or a
            Cardholder to use when you or a Cardholder make a purchase or place
            an order on the internet with your Card.
          </li>
          <li>
            <b>Account</b> - The electronic money account, also known as Modulr
            Account provided by us in accordance with these Terms and
            Conditions.
          </li>
          <li>
            <b>Account Information Service Provider</b> - means a third party
            payment service provider who is authorised by or registered with De
            Nederlandsche Bank N.V. or another European regulator to provide
            online account information services, who, with your permission will
            be able to access certain online account information on one or more
            payment accounts held by you to give you a consolidated view of your
            payment accounts.
          </li>
          <li>
            <b>Account Limits</b> - any limit that applies in relation to your
            Account and/or Card, such as account maximum balance, and limits on
            receiving and sending payments from your Account as referred in
            paragraph 2.
          </li>
          <li>
            <b>Account Manager</b> - The individuals elected by the Account
            Owner to be responsible for the management of the Account, also
            known as an “Authorised User”.
          </li>
          <li>
            <b>Account Owner</b> - The entity legally responsible for an
            Account.
          </li>
          <li>
            <b>Agreement</b> - The agreement for your Account made up of these
            Terms and Conditions, together with the Introduced Client Terms of
            Business, which constitute the entire agreement between you and
            Modulr.
          </li>
          <li>
            <b>Application Programming Interface (API)</b> - means the
            interfaces provided by Modulr to the Introduced Client (and the
            Partner Platform on the Introduced Client's behalf) to directly
            instruct Modulr Accounts via the Introduced Client's or the Partner
            Platform's own application.
          </li>
          <li>
            <b>AML Policy</b> - Modulr's written policy on anti-money laundering
            and counter terrorist financing as may be amended from time to time
            by Modulr.
          </li>
          <li>
            <b>Applicant</b> - A customer of the Partner Platform who applies
            for Modulr Products but is yet to be accepted by Modulr as an
            Introduced Client.
          </li>
          <li>
            <b>Available Balance</b> - The value of funds available on your
            Account.
          </li>
          <li>
            <b>Bacs Credit</b> - Means Bacs Direct Credit. A service enabling
            organisations to make payments to an account which takes 3 Business
            Days for the funds to be cleared.
          </li>
          <li>
            <b>Business Days</b> - Monday to Friday between the hours of 9am-5pm
            but does not include bank holidays, or public holidays in the
            Netherlands.
          </li>
          <li>
            <b>Card</b> - means a Virtual Card or a Physical Card.
          </li>
          <li>
            <b>Cardholder</b> - means the individual authorised to use the
            Physical or Virtual Card issued to you.
          </li>
          <li>
            <b>Card Scheme</b> -Mastercard and/or Visa or such other payment
            network through which Card Transactions are processed as may be made
            available to you from time to time.
          </li>
          <li>
            <b>Card Transaction</b> -means a Virtual Card Transaction or a
            Physical Card Transaction.
          </li>
          <li>
            <b>CHAPS</b> - the Clearing House Automated Payment System, a
            service enabling organisations to make same-day payments to an
            account within the UK, within the CHAPS operating days and times.
          </li>
          <li>
            <b>Chargeback</b> has the meaning given to it in Schedule 1 of the
            Introduced Client Terms of Business.
          </li>
          <li>
            <b>Consumer</b> - means a natural person not acting in the course of
            its business or profession.
          </li>
          <li>
            <b>Confidential Information</b> - any information (whether or not
            recorded in documentary form, or stored on any magnetic or optical
            disk or memory) relating to: the business, products, affairs,
            strategy, contracts, customer relationships, commercial pipelines,
            business contacts, prospective customers, existing customers,
            business models, customer pricing, management systems, business
            methods, corporate plans, maturing new business opportunities,
            research and development projects, marketing and sales information,
            sales targets and statistics, discount structures, suppliers and
            potential suppliers, source codes, computer programs inventions,
            know-how, technical specifications and other technical information
            relating to products and services.
          </li>
          <li>
            <b>Customer Services</b> - The contact centre for dealing with
            queries about your Account.
          </li>
          <li>
            <b>Data Protection Laws</b> - means all laws relating to the
            processing of Personal Data, privacy and security, including,
            without limitation, the EU Data Protection Directive 95/46/EC, the
            Dutch GDPR Implementation Act (Uitvoeringswet Algemene Verordening
            gegevensbescherming) (as may be amended from time to time) and the
            General Data Protection Regulations (EU) 2016/679 ("GDPR") together
            with equivalent legislation of any other applicable jurisdiction,
            delegated legislation of other national data protection legislation,
            and all other applicable law, regulations and approved codes of
            conduct, certifications, seals or marks in any relevant jurisdiction
            relating to the processing of personal data including the opinions,
            guidance, advice, directions, orders and codes of practice issued or
            approved by a supervisory authority or the Article 29 Working Party
            or the European Data Protection Board.
          </li>
          <li>
            <b>Due Diligence Procedure</b> - Modulr's procedures for carrying
            out due diligence on Introduced Clients in order to comply with its
            policies and regulatory obligations.
          </li>
          <li>
            <b>Faster Payment</b> - A service allowing you to make and receive
            electronic GBP payments in the which is received by the recipient
            bank within 2 hours provided that the receiving organisation or bank
            is part of Faster Payments Scheme.
          </li>
          <li>
            <b>Information</b> - Means any information related to the
            organisation, and any personal information related to Account
            Manager or the Cardholder.
          </li>
          <li>
            <b>Intellectual Property Rights</b> - means without limitation all
            patents (including models and inventions), trademarks, service
            marks, trade names, internet designations including domain names,
            business names, copyrights, design rights, database rights, rights
            to or in computer software, know-how, trade secrets, rights to or in
            confidential information and all other intellectual property rights
            and rights or forms of protection of a similar nature or effect
            which may subsist anywhere in the world whether or not registered or
            capable of registration, together with all applications for
            registration of, and any licence to use, any of the foregoing and
            "Intellectual Property" shall be construed accordingly;
          </li>
          <li>
            <b>Introduced Client</b> - Any client of Modulr which has been
            introduced by the Partner Platform and whose account is operated by
            the Partner Platform based on instructions the Partner Platform
            receives from the Introduced Client (where relevant).
          </li>
          <li>
            <b>Introduced Client Terms of Business</b> - The terms on which
            Modulr provides Modulr Products to the Introduced Client.
          </li>
          <li>
            <b>Merchant</b>- means a merchant authorised to accept Card
            Scheme-branded Cards.
          </li>
          <li>
            <b>Modulr Account Terms and Conditions</b> - This agreement, between
            Modulr and the Introduced Client which governs the terms on which
            the Introduced Client may use its Account.
          </li>
          <li>
            <b>Modulr Products</b> - those products, including but not limited
            to the Account described by the Partner Platform in the application
            process.
          </li>
          <li>
            <b>One-Time Passcode</b> - means the six-digit passcode sent to your
            mobile phone number by us, via SMS.
          </li>
          <li>
            <b>Online Portal</b> - means the interface provided by Modulr for
            the Introduced Client to access via the public internet, subject to
            applicability based on the Introduced Client's relationship with the
            Partner Platform and can be used for the management of accounts.
          </li>
          <li>
            <b>Partner Platform</b> - A third party that is permitted by Modulr
            to introduce and act on behalf of Introduced Clients, and permitted
            by you to act as an Authorised User.
          </li>
          <li>
            <b>Partner Platform Agreement</b> - an agreement between the
            Introduced Client and the Partner Platform for the provision of
            various services, under the terms of which the Introduced Client
            wishes to open an Account with Modulr to be used for the purpose and
            in accordance with the terms set out in the Partner Platform
            Agreement.
          </li>
          <li>
            <b>Payment Initiation Service Provider</b> - means a third party
            payment service provider authorised by or registered with De
            Nederlandsche Bank N.V. or another European regulator to provide an
            online service to initiate a Transaction at your request on your
            Account.
          </li>
          <li>
            <b>Physical Card</b> - means a physical card-based payment
            instrument issued by us to you which uses the Card Scheme payments
            network, as well as any version or record of such an issued payment
            instrument stored on an app or other platform, and which may be used
            to make Physical Card Transactions.
          </li>
          <li>
            <b>Physical Card Transaction</b> - means the use of a Physical Card
            to make a payment to a Merchant.
          </li>
          <li>
            <b>Regulator</b> - De Nederlandsche Bank N.V., located at Spaklerweg
            4, 1096 BA Amsterdam, Netherlands or any authority, body or person
            having, or who has had, responsibility for the supervision or
            regulation of any regulated activities or other financial services
            in the Netherlands.
          </li>
          <li>
            <b>SEPA</b> - the Single Euro Payments Area is the area where
            citizens, companies and other economic actors can make and receive
            payments in euro, within Europe, whether within or across national
            boundaries under the same basic conditions, rights and obligations,
            regardless of their location. SEPA is driven by the European
            Commission and the European Central Bank, amongst others, as a key
            component of the EU Internal Market. SEPA shall be deemed to
            encompass the countries and territories which are part of the
            geographical scope of the SEPA Schemes, as listed in the EPC List of
            SEPA Scheme Countries, as amended from time to time.
          </li>
          <li>
            <b>SEPA Credit Transfer</b> - a service allowing you to make and
            receive non-urgent EUR electronic payments within SEPA provided that
            the receiving organization or bank is part of the scheme.
          </li>
          <li>
            <b>SEPA Instant Credit Transfer</b> - a service allowing you to make
            and receive near real-time EUR electronic payments within SEPA
            provided that the receiving organization or bank is part of the
            scheme.
          </li>
          <li>
            <b>SEPA Transfers</b> - means, together, SEPA Credit Transfer and
            SEPA Instant Credit Transfer.
          </li>
          <li>
            <b>SWIFT</b> - the global member-owned financial telecommunications
            system used to facilitate the secure transfer of messages, including
            payment instructions, between financial institutions.
          </li>
          <li>
            <b>SWIFT Inbound Payment</b> - an inbound payment (in such
            currencies as may be supported by Modulr from time to time) made via
            SWIFT.
          </li>
          <li>
            <b>SWIFT Outbound Payment</b> - an outbound payment (in such
            currencies as may be supported by Modulr from time to time) made via
            SWIFT.
          </li>
          <li>
            <b>SWIFT Payments</b> - means, together, SWIFT Inbound Payments and
            SWIFT Outbound Payments (and SWIFT Payment shall be construed
            accordingly).
          </li>
          <li>
            <b>Transaction</b> - any debit, credit or other adjustment to an
            Account that affects the balance of monies held in it, including a
            Card Transaction.
          </li>
          <li>
            <b>TPP (Third Party Provider)</b> - means an Account Information
            Service Provider or a Payment Initiation Service Provider.
          </li>
          <li>
            <b>we, us, our or Modulr</b> - Modulr Finance B.V., a company
            registered in the Netherlands with number 81852401, whose registered
            office is at Weteringschans 165 C, 1017 XD Amsterdam and who is
            regulated by De Nederlandsche Bank N.V. for issuance of electronic
            money under reference number R182870.
          </li>
          <li>
            <b>Virtual Card</b> - means a virtual card-based payment instrument
            consisting of (amongst other things) a unique 16 digit account
            number issued to you which uses the Card Scheme payments network, as
            well as any version or record of such an issued payment instrument
            stored on an app or other platform, and which may be used to make
            Virtual Card Transactions.
          </li>
          <li>
            <b>Virtual Card Transaction</b> - means the use of a Virtual Card to
            make a payment to a Merchant.
          </li>
          <li>
            <b>Website</b> - means the customer portal that Introduced Clients
            can log in to in order to use the Modulr Products.
          </li>
          <li>
            <b>you, your</b> - The Account Owner, also referred to as an
            Introduced Client.
          </li>
        </ul>
        <li>
          <strong>ACCOUNT & CARD LIMITS</strong>
          <ol>
            <li>
              Limits may apply to the balance on your Account at any time, the
              maximum value of an individual payment Transaction, maximum
              Virtual Transaction value per Card, the maximum aggregate value of
              all payment Transactions made from your Account or Cards in a
              particular time period e.g. during any one Business Day and the
              maximum number of payment Transactions made from your Account over
              a particular timeframe. Your Cards may also have certain Card
              Transaction types disabled, such as cash withdrawals at an ATM.
            </li>
            <li>
              The limits and restrictions that apply to your Account and Card
              will be communicated to you during the Account set-up process
              and/or before the Card is issued to you (as applicable). These
              limits may also change over time based on your Account and/or Card
              usage; any such change will be communicated to you. You can check
              the limits at any time by contacting Customer Services. You should
              not make a payment Transaction request which exceeds such.
            </li>
            <li>
              From time to time a Card Transaction may be authorised which
              exceeds the limit or restriction applicable to your Account or
              Card, for example when it is used in an offline environment for
              example but not limited to payments for or on transport (purchases
              on a train, aeroplane, underground or toll payments). In such
              circumstance, a negative balance on your Account may occur. In
              this case the process in paragraphs 5.15 to 5.17 inclusive will
              apply.
            </li>
            <li>
              Certain Merchants may require verification that the funds held on
              your Account will cover the Card Transaction amount and will place
              a "pre-authorisation" on your Card. This amount will be
              unavailable to you until the Card Transaction is completed or
              released by the Merchant. The pre-authorisation allows the
              Merchant up to 30 days to claim and settle any funds owed to them
              from the Card. Examples include but are not limited to hotels and
              rental cars. If there are insufficient funds available on your
              Account, Modulr must still make this settlement, which may result
              in a negative balance on your Account. In this case the process in
              paragraphs 5.15 to 5.17 inclusive will apply.
            </li>
            <li>
              To manage our risk, particularly with respect to money laundering,
              fraud or security concerns, we also apply internal controls,
              including limits, to certain types of payment. We change these as
              necessary but for security purposes, we do not disclose them.
            </li>
          </ol>
        </li>
        <li>
          <strong>SCOPE OF THESE TERMS AND CONDITIONS</strong>
          <ol>
            <li>
              Your Account is an electronic money account (and therefore is not
              a traditional bank account) and the electronic money and any Card
              associated with it is issued to you by us. We are regulated by De
              Nederlandsche Bank N.V. for the issuance of electronic money. Your
              rights and obligations relating to the use of this Account are
              subject to these Terms and Conditions between you and us.
            </li>
            <li>
              The types of Transactions enabled for your Account will be
              explained to you by the Partner Platform, or as subsequently
              enabled by us. The terms of these Modulr Account Terms and
              Conditions applicable to specific Transactions or payment types
              (for example, Cards) apply only to the extent that such
              Transactions or payment types are enabled for your Account.
            </li>
            <li>
              This Agreement is written and available only in English and we
              undertake to communicate with you in English regarding any aspect
              of your Account.
            </li>
            <li>
              You agree that we or the Partner Platform may communicate with you
              by e-mail or telephone for issuing any notices or information
              about your Account and therefore it is important that you ensure
              you keep your e-mail address and mobile phone number updated.
            </li>
            <li>
              You can request a copy of these Terms and Conditions at any time
              by contacting Customer Services.
            </li>
            <li>
              By accepting these Terms and Conditions, you acknowledge that the
              Dutch Deposit Guarantee Scheme or other government-sponsored
              insurance does not apply to funds held in the Account.
            </li>
          </ol>
        </li>
        <li>
          <strong>OPENING YOUR ACCOUNT</strong>
          <ol>
            <li>
              Your Account will be opened on your behalf by the Partner
              Platform. You may only hold an Account so long as you remain an
              approved client of the Partner Platform that provided you with
              your account details.
            </li>
          </ol>
        </li>
        <li>
          <strong> USING THE ACCOUNT</strong>
          <ol>
            <li>
              Your Account can receive bank transfers and other payment types as
              added and notified to you by Modulr from time to time. Subject to
              paragraph 5.3, we will credit your Account when we receive the
              funds which could be up to three Business Days after the payment
              being instructed, depending on how the payment was sent.
            </li>
            <li>
              Your Account can also receive internal transfers from other Modulr
              Accounts owned or controlled by the Partner Platform, which apply
              instantly.
            </li>
            <li>
              An incoming payment will not be credited to your Account if:
            </li>
            <ul>
              <li>
                the Account has reached the Account Maximum Balance or Account
                Limits; or
              </li>
              <li>the Account is blocked or terminated; or</li>
              <li>
                the sender has provided incorrect/invalid Account Details for
                your Account; or
              </li>
              <li>we suspect the payment to be fraudulent.</li>
            </ul>
            <li>
              If we are unable to credit your Account for any of the reasons in
              paragraph 5.3 then the funds may be sent back to the sender
              without a prior notification to you.
            </li>
            <li>
              Your Account will be configured and operated by the Partner
              Platform. You agree that Modulr and we may take instructions from
              the Partner Platform regarding the operation of your Account,
              including the creation of beneficiaries and instruction of
              payments, on your behalf. We and Modulr have no liability for
              actions taken by the Partner Platform. If you disagree with any
              actions taken by the Partner Platform these should be discussed
              with the Partner Platform. We are also authorised to take
              instructions from any other Account Manager (where different from
              Partner Platform) and, with respect to Physical Card Transactions,
              from the Cardholder. You are responsible for all actions of the
              Account Manager and any Cardholder in relation to the Account
              and/or Card(s).
            </li>
            <li>
              Your Account can make payments out to external bank accounts via
              SEPA Transfer, Faster Payments, SWIFT Payments (if selected as a
              Modulr Product) and other methods as added and notified to you by
              the Partner Platform from time to time. With regard to SEPA
              Transfers, Modulr will automatically process inbound and outbound
              SEPA payments via SEPA Instant Credit Transfers where possible. In
              the event Modulr is unable to process such payments via SEPA
              Instant Credit Transfers, the payments will default to being made
              via SEPA Credit Transfers.
            </li>
            <li>
              Where Cards are made available to you, your Account can be used to
              fund Card Transactions. You or your Account Manager or Partner
              Platform can request a Virtual Card or a Physical Card to be
              issued to you via the Online Portal or Modulr API.
            </li>
            <li>
              Where a Virtual Card or Physical Card is issued to you, you may be
              able to register and/or store the details of the Card within
              third-party apps and/or devices and to use those third-party
              apps/devices to initiate payments with your Card. When you first
              register your Card within a third-party app/device we support, you
              may be required to verify that it is you requesting the
              registration of the Card. If you do not do this, you may not be
              able to register and use your Card through the third-party
              app/device.
            </li>
            <li>
              The value of any Card Transaction, together with any applicable
              fees and charges, will be deducted from your Account once we
              receive the authorization request from the Merchant.
            </li>
            <li>
              If the Card Transaction is made in a currency other than the
              currency the Card is denominated in, the Card Transaction will be
              converted to the currency of the Card by the relevant Card Scheme
              at a rate set by it on the day we receive details of the Card
              Transaction. The exchange rate varies throughout the day and is
              not set by us. You can check the relevant Card Scheme rate as
              follows:
            </li>
            <ul>
              <li>
                Mastercard Card Scheme rate at:{' '}
                <a href='https://www.mastercard.co.uk/en-gb/consumers/get-support/convert-currency.html'>
                  https://www.mastercard.co.uk/en-gb/consumers/get-support/convert-currency.html
                </a>
                ;
              </li>
              <li>
                VISA Card Scheme rate at:{' '}
                <a href='https://www.visa.co.uk/support/consumer/travel-support/exchange-rate-calculator.html'>
                  https://www.visa.co.uk/support/consumer/travel-support/exchange-rate-calculator.html
                </a>
                .
              </li>
            </ul>
            <li>
              If you use the Card to make a purchase online, you may be asked by
              the Merchant to use 3DS. Physical Cards are automatically enrolled
              for use with 3DS. When you use 3DS, you agree that the following
              shall apply in relation to your use of the Card:
            </li>
            <ul>
              <li>
                You must provide us with your mobile phone number before you can
                use 3DS. You must ensure that your mobile phone can receive SMS
                at the time of your purchase.
              </li>
              <li>
                When you use 3DS to purchase from a participating Merchant, you
                will be presented with an electronic receipt and the One-Time
                Passcode will be sent to your mobile phone.
              </li>
              <li>
                Without your One-Time Passcode, you will not be able to make
                purchases from participating Merchants.
              </li>
              <li>
                If you update your mobile phone number, then you must notify us
                immediately of your new details to ensure our records are
                correct.
              </li>
              <li>
                The One-Time Passcode is valid for the purchase you received it
                for. You are responsible for the security and confidentiality of
                your One-Time Passcode and must not share it with anyone else.
              </li>
              <li>
                You will be responsible for any fees or charges imposed by your
                mobile phone service provider in connection with your use of
                3DS.
              </li>
            </ul>
            <li>
              A Transaction is deemed to be authorized by you when you or your
              Account Manager or Partner Platform:
              <ul>
                <li>
                  enters the security information on the Modulr Online Portal to
                  confirm a Transaction is authorized or when it is instructed
                  via the Modulr API with the relevant security credentials;
                </li>
                <li>
                  when you or your Account Manager or Partner Platform submits a
                  request for the creation of a Virtual Card via the Online
                  Portal or Modulr API, you shall be deemed to have authorized
                  any subsequent Virtual Card Transaction made using such
                  Virtual Card up to the authorization value specified when
                  creating the request for the creation of the Virtual Card;
                </li>
                <li>
                  when you or the Cardholder (i) enter a PIN or provide any
                  other security credentials; (ii) sign a sales voucher; (iii)
                  provide the Physical Card details and/or provide any other
                  details as requested; (iv) wave/swipe the Physical Card over a
                  card reader; or (v) insert the Physical Card into a card
                  device or an ATM;
                </li>
                <li>
                  when you give instructions through a third party (such as the
                  recipient of a Payment Initiation Service Provider).
                </li>
              </ul>
              <p>
                Once the Transaction is confirmed, we cannot revoke the
                Transaction save for in those circumstances set out in paragraph
                5.13 below.
              </p>
            </li>
            <li>
              You can cancel any Transaction which is agreed to take place on a
              date later than the date you authorized it, provided that you give
              us notice to cancel no later than the close of business on the
              Business Day before the Transaction was due to take place.
            </li>
            <li>
              Cancelling a recurring Card Transaction with us will not cancel
              the agreement with the organization you are paying. It is your
              responsibility to tell the organization collecting the payment
              about the changes to your instructions.
            </li>
            <li>
              If for any reason whatsoever, a negative balance arises because a
              Transaction is completed when there are not enough funds on your
              Account for that Transaction, you shall reimburse the negative
              balance amount immediately, unless circumstances described in
              sections 5.16 and 5.17 apply. You agree that once we make this
              negative balance known to you, we will charge you the amount of
              the negative balance, and you must repay it immediately. We may
              set-off the amount of the negative balance against any funds on
              your Account, including any subsequently loaded funds. Until we
              are reimbursed this negative balance amount, we may arrange for
              your Account, including Card(s), to be suspended. We may also
              report the negative balance to credit reference agencies.
            </li>
            <li>
              Where a negative balance arises because of an error on the part of
              a Merchant where the Card Transaction occurred, we will seek to
              recover the negative balance amount from the Merchant.
            </li>
            <li>
              Where a negative balance arises because of an error on the part of
              the recipient of the payment or us, we will seek to recover the
              negative balance amount from the person who made the error.
            </li>
            <li>
              The Available Balance on your Account will not earn any interest.
            </li>
            <li>
              You can check the balance and Transaction history of your Account
              at any time via the interface provided to you by the Partner
              Platform or by contacting Customer Services, or the Online Portal
              if you have relevant access details.
            </li>
            <li>
              You will be provided with a monthly statement free of charge
              setting out information relating to individual payment
              Transactions by the Partner Platform or us (using the details we
              have associated with your Account).
            </li>
          </ol>
        </li>
        <li>
          <strong>THIRD PARTY ACCESS</strong>
          <ol>
            <li>
              You can instruct a TPP to access information on your Account or
              initiate certain Transactions from your Account provided such TPP
              has identified itself to us and it has acted in accordance with
              the relevant regulatory requirements. We will treat any
              instruction from a TPP as if it was from you or an Account
              Manager.
            </li>
            <li>
              We may deny a TPP access to your Account if we are concerned about
              unauthorised or fraudulent access by that TPP. Setting out the
              reason for such denial. Before doing so, we will tell you that we
              intend to deny access and give our reasons for doing so unless it
              is not reasonably practicable, in which case we will immediately
              inform you afterwards. In either case, we will tell you in the
              manner in which we consider most appropriate in the circumstances.
              We will not tell you if doing so would compromise our security
              measures or would otherwise be unlawful.
            </li>
            <li>
              If you have provided consent to a TPP to access the data in your
              Account to enable them to provide account information services to
              you or initiate Transactions on your behalf, you consent to us
              sharing your information with the TPP as is reasonably required
              for them to provide their services to you. You must let us know if
              you withdraw this permission and we recommend you let the TPP
              know. On notification from you, we will not provide such TPP
              access to your Account or the data in it.
            </li>
          </ol>
        </li>
        <li>
          <strong>CLOSING YOUR ACCOUNT</strong>
          <ol>
            <li>
              You may close your Account by contacting Customer Services. Please
              refer to your contract with the Partner Platform for any terms
              relating to your need to maintain your Account.
            </li>
            <li>
              The Account will be closed if the Partner Platform instructs us to
              close your Account (in which case the Partner Platform will inform
              you of this instruction).
            </li>
            <li>
              On termination of the Agreement for any reason, these Terms and
              Conditions will automatically terminate, and your Account will be
              closed, and any Cards issued to you will be cancelled.
            </li>
            <li>
              Any Available Balance remaining on the Account after Account
              closure will be transferred to your nominated bank account via
              SEPA Transfer based on instructions to us from the Partner
              Platform. If for any reason this is not possible, such Available
              Balance will remain yours, and you may at any time request a
              refund by contacting Customer Services. You will not have any
              access to your Account from the date of Account closure, and this
              Agreement will terminate.
            </li>
          </ol>
        </li>
        <li>
          <strong>YOUR LIABILITY AND AUTHORISATIONS</strong>
          <ol>
            <li>
              You are responsible for understanding and complying with the
              Agreement, including these Terms and Conditions.
            </li>
            <li>
              We may at any time suspend, restrict or refuse to authorize any
              use of your Account, Cards (including cancelling Card(s)) or
              refuse to process your instructions or authorize any particular
              Transaction where:
              <ol>
                <li>
                  we are concerned about the security of or access to your
                  Account and/or your Card;
                </li>
                <li>
                  we know or suspect that your Account and/or Card is being used
                  in an unauthorized or fraudulent manner;
                </li>
                <li>
                  we need to do so in order to comply with the law or otherwise
                  for regulatory or crime prevention purposes;
                </li>
                <li>
                  the Transaction would breach the limits applicable to your
                  Account and/or Card;
                </li>
                <li>
                  you, the Account Manager, or the Cardholder breach an
                  important part of these Terms and Conditions, or repeatedly
                  breach any term in this Agreement and fail to resolve the
                  matter in a timely manner.
                </li>
              </ol>
            </li>
            <li>
              If we cancel, suspend, or restrict your Account and/or Card(s), or
              otherwise refuse to execute a payment order or initiate a
              Transaction, we will notify you or the Partner Platform of the
              refusal, suspension, or cancellation (as applicable) without undue
              delay, provided we are legally permitted to do so. If possible, we
              will provide the reasons for the refusal and the procedure for
              rectifying any factual errors that led to the refusal.
            </li>
            <li>
              You, the Account Manager, or Cardholder must not:
              <ol>
                <li>
                  allow another person to use security information related to
                  the Account, Cards, and/or app/device used for Transactions;
                </li>
                <li>
                  disclose passwords or any security information to any other
                  person, verbally or in a way that allows observation by
                  others.
                </li>
              </ol>
            </li>
            <li>
              You must take all reasonable steps to keep your Account,
              password(s), and other security-related details safe, including
              those related to any registered app and/or devices. If you receive
              a request for your password from a non-Modulr website or have
              doubts about a website's genuineness, report it to us or contact
              Customer Services. In case of any indication of compromise, change
              your password immediately and notify us promptly.
            </li>
            <li>
              In the event of an unauthorized Transaction, we will refund the
              amount to you within one Business Day following notification, with
              your maximum liability limited to €50. However, you will bear all
              losses and liability for:
              <ol>
                <li>
                  Transactions resulting from fraud, intentional or grossly
                  negligent breach of these Terms and Conditions;
                </li>
                <li>
                  Transactions made by the Partner Platform, other Account
                  Managers, Cardholders, or authorized TPPs;
                </li>
                <li>
                  Unauthorized Transactions due to the use of lost or stolen
                  Physical Cards or compromised security information of the
                  Account, Cards, or app/device where your Card is
                  registered/stored.
                </li>
              </ol>
            </li>
            <li>
              Keep us updated with changes to your information, including email
              address and mobile numbers, to ensure effective communication
              regarding your Account and any changes to these Terms and
              Conditions.
            </li>
            <li>
              If you request to recall a Transaction caused by an error or
              mistake not attributable to Modulr, we reserve the right to charge
              a handling fee of €25 per recall, along with any applicable fees
              payable to third-party banks or institutions for handling the
              recall.
            </li>
            <li>
              You agree to indemnify and hold harmless us, Modulr, our
              distributors, partners, agents, sponsors, service providers, and
              their group companies from any costs of legal action taken to
              enforce this Agreement, including these Terms and Conditions, and
              any breach of these Terms and Conditions by you.
            </li>
          </ol>
        </li>
        <li>
          <strong>DISPUTES AND INCORRECT TRANSACTIONS</strong>
          <ol>
            <li>
              If you (or an Account Manager or Cardholder) have a reason to
              believe that:
              <ol>
                <li>
                  a Transaction on your Account was unauthorized or made
                  incorrectly,
                </li>
                <li>a Physical Card is lost or stolen, or</li>
                <li>
                  someone else (other than TPP) knows the security credentials
                  or has unauthorized access to your Account and/or Card,
                </li>
              </ol>
              you must inform us immediately by contacting Customer Services.
              After you notify us, we will replace a lost, stolen, or
              misappropriated Physical Card and/or security credentials, as
              appropriate.
            </li>
            <li>
              We will investigate your claim for a refund of unauthorized or
              incorrectly executed Transactions, provided that you have notified
              us without undue delay upon becoming aware of such incorrectly
              executed or unauthorized Transaction, and in any case within the
              timeframes required by the Card Scheme rules for Card Transactions
              or within 13 months of the date of the relevant Transaction for
              all other Transactions. We will not be liable for any unauthorized
              or incorrectly executed Transactions notified to us after this
              period.
            </li>
            <li>
              If you dispute a Transaction:
              <ol>
                <li>
                  Subject to 9.3.2 and 9.3.3, we will immediately refund the
                  amount to your Account to the position it would have been in
                  if the unauthorized Transaction had not taken place. We will
                  have no further liability to you. If we subsequently discover
                  that you were not entitled to a refund, we shall treat the
                  refund as a mistake and be entitled to reapply the
                  Transaction.
                </li>
                <li>
                  If there are reasonable grounds for thinking that you may not
                  be entitled to a refund, we may investigate before giving you
                  a refund and provide you with our supporting evidence if we
                  believe you are not entitled to the refund.
                </li>
                <li>
                  If the Transaction was initiated through a TPP, it is for the
                  TPP to prove that the Transaction was authenticated,
                  accurately recorded, and not affected by a technical breakdown
                  or other deficiency linked to the TPP's payment initiation
                  service.
                </li>
              </ol>
            </li>
            <li>
              If an incorrect Transaction is paid into your Account that should
              not have been, we will, where possible, immediately send the funds
              back to the bank acting for the person from whose account the
              Transaction was made. In such circumstances, you agree to return
              the funds to us and provide the necessary assistance to recover
              the amount from you. If we cannot recover the funds, we are
              required to provide sufficient details about you and the incorrect
              payment to the bank or institution that sent the payment to enable
              them to recover the funds.
            </li>
            <li>
              You will be liable for all Transactions made from your Account if
              you (or the Account Manager or the Cardholder) have acted
              fraudulently or have failed with gross negligence:
              <ol>
                <li>
                  to keep the security credentials used to access or use your
                  Account and/or Card safe and secure or otherwise failed to
                  comply with these Terms and Conditions in relation to the
                  safety of your Account and/or Card, or
                </li>
                <li>failed to notify us in accordance with 9.1 above.</li>
              </ol>
            </li>
            <li>
              You may be entitled to a refund for a Transaction initiated by a
              payee if:
              <ol>
                <li>the authorization did not specify the exact amount,</li>
                <li>
                  the amount of the Transaction exceeded what you could
                  reasonably have expected, taking into account your previous
                  spending pattern and other relevant circumstances (we may
                  request information to determine if this is correct), and
                </li>
                <li>
                  you requested a refund within 8 weeks of the date the
                  Transaction was debited to your Account.
                </li>
              </ol>
              In such circumstances, we will refund you within 10 Business Days
              of receiving your claim for a refund or, where applicable, within
              10 Business Days of receiving any further requested information.
              If we refuse the refund, we will provide you with reasons for the
              refusal.
            </li>
          </ol>
        </li>
        <li>
          <strong>VARIATION</strong>
          <ol>
            <li>
              We may change these Terms and Conditions by providing you with at
              least two months' prior notice by e-mail (provided you have
              supplied us with an up-to-date e-mail address).
            </li>
            <li>
              If you do not agree with the changes to the Terms and Conditions,
              you may notify us at any time within the two months' notice
              period, and these Terms and Conditions will be terminated, and
              your Account closed free of charge. If you do not notify us
              otherwise during this period, you will be deemed to have accepted
              the change, and it will apply to you when it comes into force.
            </li>
            <li>
              If any part of these Terms and Conditions is inconsistent with any
              legal requirements, we will not rely on that part but treat it as
              if it actually reflected the relevant legal requirement. If
              operational changes are necessary to fully comply with the new
              regulatory requirement, we will make those changes as soon as
              reasonably practical.
            </li>
          </ol>
        </li>
        <li>
          <strong>TERMINATION OR SUSPENSION</strong>
          <ol>
            <li>
              We can terminate your Account at any time if we give you two
              months' notice and transfer any Available Balance at the time to
              your nominated bank account without a charge.
            </li>
            <li>
              We can suspend or terminate your Account at any time with
              immediate effect (and until your default has been remedied or the
              Agreement terminated) without any prior notice to you if:
              <ol>
                <li>
                  we discover that any of the Information we hold for you is
                  false, misleading, or materially incorrect, or
                </li>
                <li>
                  you, the Account Manager, the Cardholder, or a third party has
                  engaged in fraudulent activity, money laundering, terrorism,
                  terrorism financing, or other illegal activity in connection
                  with your Account, or we have reasonable suspicions in respect
                  of the same, or
                </li>
                <li>you have reached your Account Limit, or</li>
                <li>
                  you or the Account Manager have breached these Terms and
                  Conditions, or
                </li>
                <li>
                  we are required to do so under any applicable law or
                  regulation or at the direction of any regulatory, law
                  enforcement, or other competent authority.
                </li>
              </ol>
            </li>
            <li>
              In the event that we do suspend or terminate your Account, we will
              inform you in advance if possible; otherwise, we will notify you
              immediately afterwards to the extent permitted by law.
            </li>
          </ol>
        </li>
        <li>
          <strong>OUR LIABILITY</strong>
          <ol>
            <li>
              Our liability in connection with these Terms and Conditions
              (whether arising in contract, tort, breach of statutory duty, or
              otherwise) shall be subject to the following exclusions and
              limitations:
              <ol>
                <li>
                  We shall not be liable for any default resulting directly or
                  indirectly from any cause beyond our control, including but
                  not limited to a lack of funds.
                </li>
                <li>
                  We shall not be liable for any loss of profits, loss of
                  business, or any indirect, consequential, special, or punitive
                  losses.
                </li>
                <li>
                  Where sums are incorrectly deducted from your Available
                  Balance due to our default, our liability shall be limited to
                  payment to you of an equivalent amount to that which was
                  incorrectly deducted from your Available Balance.
                </li>
                <li>
                  In all other circumstances of our default, our liability will
                  be limited to transferring any Available Balance to your
                  nominated bank account.
                </li>
              </ol>
            </li>
            <li>
              In circumstances where sums are incorrectly deducted from your
              Available Balance due to our fault, if we require your support to
              enable us to recover the incorrect deduction, you agree to provide
              us with all assistance that we reasonably require.
            </li>
            <li>
              Nothing in these Terms and Conditions shall exclude or limit our
              liability for death or personal injury resulting from our
              negligence or fraud.
            </li>
            <li>
              To the extent permitted by law, all conditions or warranties
              implied by law, statute, or otherwise are expressly excluded.
            </li>
            <li>
              The above exclusions and limitations set out in this paragraph
              shall apply to any liability of our affiliates and other
              suppliers, contractors, agents, or distributors and any of their
              respective affiliates (if any) to you, which may arise in
              connection with these Terms and Conditions.
            </li>
          </ol>
        </li>
        <li>
          <strong>YOUR INFORMATION</strong>
          <ol>
            <li>
              Some personal data will be necessary for us to provide you with
              the Account and services under this Agreement. Modulr is a Data
              Controller and shall only use your personal data for this purpose.
              Please see the Privacy Policy (please contact Customer Services
              for details of where to access this) for full details on the
              personal data that we hold, how we will use it, and how we will
              keep it safe. Modulr will at all times comply with Data Protection
              Laws.
            </li>
            <li>
              We will retain details of individual transactions for six years
              from the date on which the particular transaction was completed.
              We will maintain all other records for six years from when we have
              ceased to provide you with any product or service.
            </li>
            <li>
              You must update any changes to your Information by contacting
              Customer Services.
            </li>
            <li>
              If we discover that the Information we hold about you is
              incorrect, we may have to suspend or cancel your Account until we
              can establish the correct Information in order to protect both
              parties.
            </li>
            <li>
              If you or the Account Manager allow or give consent to an
              Authorized Third-Party Provider to access your Account to provide
              their services, you should know that we have no control over how
              an Authorized Third-Party Provider will use your information, nor
              will we be liable for any loss of information after an Authorized
              Third-Party Provider has access to your information.
            </li>
          </ol>
        </li>
        <li>
          <strong>COMPLAINTS PROCEDURE</strong>
          <ol>
            <li>
              Complaints regarding any element of the service provided by us can
              be sent to Customer Services.
            </li>
            <li>
              All complaints will be subject to our complaints procedure. We
              will provide you with a copy of our complaints procedure upon
              request, and if we receive a complaint from you, a copy of our
              complaints procedure will automatically be posted or emailed to
              you.
            </li>
            <li>
              In most cases, we will provide a full response by email to your
              complaint within fifteen Business Days after the date we receive
              your complaint. In exceptional circumstances where we are unable
              to respond in full to your complaint, we will inform you of the
              delay and provide our reasons, along with the timeframe within
              which you will receive a full reply. This full reply will be
              provided within thirty-five days of the date we received your
              complaint.
            </li>
            <li>
              If we fail to resolve your complaint to your satisfaction, any
              disputes must be submitted to the exclusive jurisdiction of the
              competent courts in Amsterdam, the Netherlands, except as subject
              to your local statutory rights. If you qualify as a Consumer
              (i.e., non-business or professional user), you may also refer your
              complaint to the Financial Services Complaints Tribunal (Kifid -
              www.kifid.nl).
            </li>
          </ol>
        </li>
        <li>
          <strong>GENERAL</strong>
          <ol>
            <li>
              Any delay or failure to exercise any right or remedy under these
              Terms and Conditions by us shall not be construed as a waiver of
              that right or remedy or preclude its exercise at any subsequent
              time.
            </li>
            <li>
              If any provision of these Terms and Conditions is deemed
              unenforceable or illegal, the remaining provisions will continue
              in full force and effect.
            </li>
            <li>
              You may not assign or transfer any of your rights and/or benefits
              under these Terms and Conditions, and you shall be the sole party
              to the contract between us. You will remain liable until the
              Account issued to you is terminated. We may assign our rights and
              benefits at any time without prior written notice to you. We may
              subcontract any of our obligations under these Terms and
              Conditions.
            </li>
            <li>
              No third party who is not a party to these Terms and Conditions
              has a right to enforce any of the provisions in these Terms and
              Conditions.
            </li>
            <li>
              You can obtain a copy of this Agreement at any time by contacting
              Customer Services.
            </li>
            <li>
              These Terms and Conditions - including any contractual and
              non-contractual obligations hereto - are governed by the laws of
              the Netherlands, and you agree to the exclusive jurisdiction of
              the Courts of Amsterdam.
            </li>
            <li>
              This Account is not covered by a compensation scheme. As a
              responsible e-money issuer, we will ensure that once we have
              received your funds, they are deposited in a secure account
              specifically for the purpose of redeeming Transactions made from
              your Account and will be safeguarded in accordance with our
              obligations under the Dutch Financial Supervision Act (Wet op het
              financieel toezicht). In the event that we become insolvent, funds
              that you have loaded which have arrived with and been deposited by
              us are protected against the claims made by our creditors in line
              with Dutch law.
            </li>
            <li>
              Exclusion of relevant statutory provisions: the following
              provisions of the Netherlands Civil Code do not apply in the
              relationship between Modulr and the Introduced Client: articles
              7:516, 7:517, 7:518, and 7:519, article 7:520(1), article
              7:522(3), article 7:527, articles 7:529 to 7:531, article 7:534,
              and articles 7:543, 7:544, and 7:545 of the Netherlands Civil
              Code, and all legislation pursuant to and/or based on such
              articles. Furthermore, if not already covered by the articles
              referred to in the preceding sentence, the rules regarding
              provision of information in the Market Conduct Supervision
              (Financial Institutions) Decree (Besluit gedragstoezicht
              financiële ondernemingen Wft) that follow from Title III PSD2 do
              not apply. The above contains the exclusion of the relevant
              provisions of PSD2 as implemented in Dutch law. Consequently, all
              rules with regard to the content and provision of the information
              required by Title III of PSD2 and the following provisions of
              Title IV of PSD2 do not apply to this Agreement: article 62(1),
              article 64(3), article 72, article 74, article 76, article 77,
              article 80, and article 89 of PSD2, and all legislation pursuant
              to and/or based on such articles. This paragraph shall not apply
              if the Introduced Client is a Consumer.
            </li>
          </ol>
        </li>
        <li>
          <strong>CONTACTING CUSTOMER SERVICES</strong>
          <ol>
            <li>
              Customer Services are provided by the Partner Platform. The
              details shall be provided by Partner Platform.
            </li>
          </ol>
        </li>
      </ol>
      <h4 id='eea-safeguarding'>EEA Safeguarding Information</h4>
      <p>
        <strong>Safeguarding: How Modulr keeps customer funds safe</strong>
      </p>
      <p>
        <strong>Who is Modulr?</strong>
      </p>
      <p>
        Modulr enables thousands of businesses of all sizes across the UK and
        Europe to efficiently pay-in, collect and disburse funds instantly into
        a range of accounts, wallets and cards. We've created an
        industry-leading platform, connected to an expanding network of
        accounting and payroll platforms. Our payments expertise and extensive
        product capability also enables us to solve specific problems for a
        growing portfolio of hundreds of clients in a range of industry
        verticals.
      </p>
      <p>
        <strong>Is Modulr a bank?</strong>
      </p>
      <p>
        Modulr is not a bank, we're an Electronic Money Institution (EMI). An
        EMI is an organisation that has been authorised by the regulator to
        issue e-money accounts and provide payment services. In the EEA, we're
        regulated by De Nederlandsche Bank.
      </p>
      <p>
        <strong>How is Modulr different from a bank?</strong>
      </p>
      <p>
        One of the main differences between Modulr, an EMI, and a bank is that
        banks lend money, whereas EMIs are prohibited from lending money.
        Specifically, banks receive deposits from customers that they use to
        lend money out and make a profit on the difference. By contrast, an EMI
        such as Modulr does not lend any customer funds or offer interest on
        balances. Our payment services however are regulated by the same
        payments regulations that apply to banks.
      </p>
      <p>
        <strong>How does Modulr protect customer funds?</strong>
      </p>
      <p>
        Modulr is required by law to use a process called Safeguarding to
        protect customer money. This means we ensure that the funds we receive
        in exchange for e-money are segregated from all other funds that we hold
        and they cannot be used for any other purposes. The funds we safeguard
        are therefore completely separate from the additional funds that Modulr
        holds to meet its corporate obligations and run its business. These
        safeguarded funds are held at credit institutions (banks) in specially
        designated accounts belonging to Stichting Custodian Modulr Finance, an
        entity whose sole purpose is to ensure the safeguarding of funds for
        Modulr customers. Furthermore, as an EMI, we must also hold an
        additional amount equal to 2% of the total value of safeguarded client
        funds in our own funds, which are held separately to those client funds.
        The purpose of the 2% additional funds is to ensure that, in the case of
        any problems with our business, there are enough funds to support an
        orderly business wind-down and the process of returning of client funds.
        Combining this '2%' requirement with safeguarding means that there is a
        protection mechanism to help ensure an orderly wind-down and return of
        customer funds if ever required.
      </p>
      <p>
        <strong>What is the DGS and is it applicable to Modulr?</strong>
      </p>
      <p>
        The DGS is the Deposit Guarantee Scheme, which protects money in Dutch
        bank accounts up to a maximum of €100,000 per person, per bank. DNB and
        the Deposit Guarantee Fund (DGF) are jointly responsible for the DGS.
        The DGS is not applicable to EMIs such as Modulr. However, as mentioned,
        our safeguarding requirements mean that all customer money held at
        Modulr, regardless of the amount, is segregated from all other funds
        that we hold and cannot be used for any other purpose. So, while the DGS
        is not applicable to e-money, the regulatory requirements outlined above
        are designed to protect the balance of customer funds, as opposed to
        only compensating up to a maximum limit, as is the case with the DGS.
      </p>
      <p>
        <strong>Where is money safeguarded?</strong>
      </p>
      <p>
        Modulr must deposit the value of all the e-money it has issued to
        customers at a credit institution (bank). These safeguarded funds are
        held at credit institutions (banks) in specially designated accounts
        belonging to Stichting Custodian Modulr Finance, an entity whose sole
        purpose is to ensure the safeguarding of funds for Modulr customers, in
        line with Dutch legislation.
      </p>
      <p>
        <strong>What would happen in the event of Modulr's insolvency?</strong>
      </p>
      <p>
        In addition to our safeguarding obligations and the requirement to
        maintain an additional 2% of corporate funds as regulatory capital,
        we're also required to prepare orderly wind-down plans. These plans are
        a regulatory requirement and include the early identification of a
        potential insolvency event and the return of your funds before an
        insolvency process commences, if possible.
      </p>
      <p>
        In the event that Modulr becomes insolvent, your funds are separate from
        the funds of Modulr and therefore the creditors of Modulr (other third
        parties that are owed money from Modulr) are not able to make a claim
        against safeguarded funds and would not affect your entitlement to your
        funds. An independent insolvency professional (referred to as an
        'insolvency practitioner') would be appointed to return your funds to
        you. However, where an insolvency practitioner is unable to take their
        costs of sending the funds to you from elsewhere (for example, the
        general pot of Modulr funds remaining or from the additional 2% own
        funds described above) they are entitled to take their costs from
        safeguarded funds which would include your funds. In this unlikely
        circumstance, you may not receive the total value of your funds.
      </p>
      <p>
        <strong>Who regulates Modulr in the EEA?</strong>
      </p>
      <p>
        Modulr Finance B.V. is licensed and regulated by De Nederlandsche Bank
        (Relatienummer R182870) as an Electronic Money Institution.
      </p>
      <hr className='section-divider' />
    </>
  );
};

export default ModulrTermsEU;
